import MultiplierHelper from '@/helper/MultiplierHelper'
import CoreHelper from '@/helper/CoreHelper'

const moment = require('moment')
const hourEndNormal = '17'

class EstimativeHelper {
  static salesEstimative (item) {
    let itemDate = moment(item.date, 'DD/MM/YYYY')

    if (CoreHelper.isToday(itemDate)) {
      let lastUpdate = item.updatedAt
      let lastUpdateHour = lastUpdate.format('HH')

      let hold = item.on_hold
      let payout = item.payout

      // Calculate normal interval
      if (lastUpdateHour < hourEndNormal) {
        let diff = hourEndNormal - lastUpdateHour

        hold += (hold / lastUpdateHour) * diff
        payout += (payout / lastUpdateHour) * diff
      }

      // Calculate after normal interval
      let multiplier = MultiplierHelper.getById(item.affiliate_name)
      if (multiplier.hasOwnProperty('value')) {
        let indexAfter = parseFloat(multiplier.value)

        hold *= indexAfter
        payout *= indexAfter
      }

      return {
        hold: hold,
        payout: payout
      }
    }

    return null
  }
}

export default EstimativeHelper
